import {useMemo} from 'react';
import {GlobalContext} from './GlobalContext.js';
import {isSandboxUrl} from '@/lib/utils/isSandboxUrl';

export const GlobalContextProvider = ({children}) => {
    const value = useMemo(() => {
        return {
            isSandbox: isSandboxUrl(window.location.origin),
        };
    }, []);

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
};
